import { atom } from "jotai";

export const userIdAtom = atom<string>("");
export const isShowDrawerInMobileAtom = atom<boolean>(false);
export const tokenAtom = atom<string>("");
export const isMobileAtom = atom<boolean | null>(null);

export interface LanguageOption {
  label: string;
  value: string;
}

export const languageAtom = atom<LanguageOption>({ label: "EN(US)", value: "en" });
export const isMutedAtom = atom<boolean>(false);

// New atoms for storing the reference data from the API
export const referenceKeyAtom = atom<string>("");
export const referenceExpiresAtAtom = atom<string>("");

export const isInitModalOpenAtom = atom<boolean>(false);
